__turbopack_context__.v({
  "body": "calendar-module-scss-module__1XK2NG__body",
  "cellDisabled": "calendar-module-scss-module__1XK2NG__cellDisabled",
  "clear": "calendar-module-scss-module__1XK2NG__clear",
  "dayButton": "calendar-module-scss-module__1XK2NG__dayButton",
  "disabled": "calendar-module-scss-module__1XK2NG__disabled",
  "dpNav": "calendar-module-scss-module__1XK2NG__dpNav",
  "header": "calendar-module-scss-module__1XK2NG__header",
  "monthCaption": "calendar-module-scss-module__1XK2NG__monthCaption",
  "monthCell": "calendar-module-scss-module__1XK2NG__monthCell",
  "monthCellSelected": "calendar-module-scss-module__1XK2NG__monthCellSelected",
  "monthsGrid": "calendar-module-scss-module__1XK2NG__monthsGrid",
  "nav": "calendar-module-scss-module__1XK2NG__nav",
  "outside": "calendar-module-scss-module__1XK2NG__outside",
  "selected": "calendar-module-scss-module__1XK2NG__selected",
  "today": "calendar-module-scss-module__1XK2NG__today",
  "weekday": "calendar-module-scss-module__1XK2NG__weekday",
  "weekdays": "calendar-module-scss-module__1XK2NG__weekdays",
  "yearCell": "calendar-module-scss-module__1XK2NG__yearCell",
  "yearCellSelected": "calendar-module-scss-module__1XK2NG__yearCellSelected",
  "yearsGrid": "calendar-module-scss-module__1XK2NG__yearsGrid",
});
